import React from 'react'
import { cn } from '@/lib/utils'

interface LogoProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
  showText?: boolean
  isOpen?: boolean
  invert?: boolean
}

export const Logo: React.FC<LogoProps> = ({ className, size = 'md', showText = false, isOpen = false }) => {
  const sizes = {
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-12 w-12'
  }

  const textSizes = {
    sm: 'text-base',
    md: 'text-lg',
    lg: 'text-xl'
  }

  return (
    <div className={cn('flex items-center justify-center w-full gap-3', className)}>
      <img src="/images/logos/logo-nina.svg" alt="Mãe Nutrida" className={cn('flex-shrink-0', sizes[size])} />
      {showText && !isOpen && (
        <div className="flex flex-col leading-tight">
          <span className={cn('font-bold text-coentro', textSizes[size])}>mãe nutrida</span>
          <span className="text-xs text-muted-foreground">Materno-infantil</span>
        </div>
      )}
    </div>
  )
}
